<div class="modal-backdrop" [class.show]="isVisible" (click)="onBackdropClick($event)">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="title">
        <h2>Términos y condiciones de Suscripción Débito Automático - Seguro Digital SURA</h2>
        <div class="icon" (click)="close()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 201 201" fill="none">
            <path
              d="M146.117 173.554C132.833 181.893 117.177 186.774 100.301 186.774C76.4446 186.774 54.8245 177.079 39.1685 161.418C23.5125 145.758 13.8885 124.199 13.8207 100.267C13.8207 83.3855 18.7005 67.7246 27.0368 54.4367C31.4421 48.4028 30.1544 39.9284 24.1225 35.5216L16.2606 46.2334C6.22991 61.8264 0.333496 80.4024 0.333496 100.334C0.333496 155.588 45.0649 200.333 100.301 200.333C120.227 200.333 138.797 194.435 154.386 184.333C160.214 179.859 161.434 171.452 157.029 165.554L146.117 173.554Z"
              fill="#2D6DF6"
            />
            <path
              d="M200.266 100.332C200.266 45.0787 155.535 0.333496 100.298 0.333496C79.6947 0.333496 60.5144 6.6385 44.5873 17.3502C38.8265 21.9603 37.8098 30.2992 42.283 36.1975L53.0592 27.9942C66.6819 19.1129 82.8123 13.8927 100.298 13.8927C124.155 13.8927 145.775 23.5874 161.431 39.2483C177.087 54.9091 186.711 76.4681 186.779 100.4C186.779 117.891 181.56 134.095 172.682 147.654C168.141 153.62 169.293 162.094 175.257 166.637L183.322 156.128C194.031 140.196 200.334 121.01 200.334 100.4L200.266 100.332Z"
              fill="#2D6DF6"
            />
            <path
              d="M63.3614 126.3L53.8052 135.859C58.9561 141.011 67.1568 141.147 72.4432 136.333L98.8754 109.961L125.308 136.401L134.389 145.486C139.54 140.333 139.405 131.859 134.593 126.503L108.499 100.334L134.457 74.368L144.013 64.8088C138.863 59.6563 130.662 59.5207 125.375 64.3342L98.9432 90.7068L72.511 64.2664L63.4292 55.1818C58.2783 60.3343 58.4139 68.8087 63.2259 74.1646L89.3192 100.334L63.3614 126.3Z"
              fill="#2D6DF6"
            />
          </svg>
        </div>
      </div>
      <section class="contenido">
        <section>
          <p>
            <strong>Última actualización:</strong> 21/10/2015<br />
            <strong>Versión:</strong> 21 de octubre de 2025
          </p>
          <p>
            Al pagar con tarjeta, aceptas que SURA cobre automáticamente el valor de tu seguro según la frecuencia que elijas (mensual o
            anual). A continuación te explicamos cómo funciona, en sencillo:
          </p>
        </section>

        <section>
          <h3>1. ¿Qué estás aceptando?</h3>
          <p>
            Al hacer clic en "Pagar con tarjeta", autorizas a SURA a cobrar de forma automática las próximas cuotas de tu seguro en la misma
            tarjeta que registraste. No tendrás que ingresar cada mes a pagar ni encontrarás tus recibos en pago express, el cobro se hace
            solo, en la fecha que corresponde según los días del mes en que hayas realizado la compra.
          </p>
        </section>

        <section>
          <h3>2. ¿Cómo se hacen los cobros?</h3>
          <ul>
            <li>Al momento de la compra del seguro digital Puedes elegir pago mensual (cada mes) o anual (una vez al año).</li>
            <li>
              La compra del seguro significa realizar el primer pago ingresando la información de la tarjeta en la pasarela de pagos. Dicha
              tarjeta es la que se tokeniza para los cobros recurrentes futuros.
            </li>
            <li>
              Si la compra del seguro digital fue realizada entre el día 1 y 14 del mes, SURA hará automáticamente los cobros los días 15 de
              cada mes. Si la compra del seguro fue realizada entre los días 15 y 30 del mes, SURA hará automáticamente los cobros el último
              día calendario del mes.
            </li>
          </ul>
        </section>

        <section>
          <h3>3. Seguridad de tus datos</h3>
          <p>
            SURA no guarda los datos de tu tarjeta. Los cobros se procesan a través de la pasarela de pagos, que usa un sistema seguro de
            tokenización y cumple con los estándares internacionales de seguridad (PCI DSS).
          </p>
        </section>

        <section>
          <h3>4. Si un cobro falla</h3>
          <ul>
            <li>Si el cobro no se logra hacer de forma efectiva, se harán hasta dos intentos adicionales en los días siguientes.</li>
            <li>
              Si no se logra el cobro en el tercer intento, se te avisará por correo o mensaje para que actualices tu medio de pago y pagues
              manualmente en el link asignado.
            </li>
            <li>
              Si no se regulariza el pago, la cobertura del seguro puede suspenderse o cancelarse. Pasados 60 días sin obtener el pago de
              alguna cuota, se cancela el seguro por falta de pago.
            </li>
          </ul>
        </section>

        <section>
          <h3>5. Notificaciones</h3>
          <p>SURA te avisará por correo o mensaje cuando:</p>
          <ul>
            <li>Hayan cambios en el valor del seguro.</li>
            <li>
              Haya intentado hacer el cobro y no se haya efectuado de forma correcta, por lo que te avisará el monto a tener disponible.
            </li>
            <li>Hayan pasado los 3 intentos de cobro automático y se genere tu link de pago para mantener el seguro activo.</li>
            <li>Se acerque el momento de tu renovación automática.</li>
            <li>Haya cancelación por falta de pago.</li>
          </ul>
          <p>Por eso es importante que te asegures de mantener actualizados tus datos de contacto.</p>
        </section>

        <section>
          <h3>6. Cómo cancelar el débito automático</h3>
          <p>
            Puedes cancelar el débito automático o el seguro en cualquier momento a través de los canales de atención de SURA. La
            cancelación aplica desde el siguiente pago y no afecta los cobros ya realizados.
          </p>
        </section>

        <section>
          <h3>7. En caso de pagos duplicados o errores</h3>
          <p>
            Si se hace un cobro duplicado o por error, puedes avisar a SURA dentro de los 30 días siguientes. Si se confirma el error, SURA
            hará la devolución o abonará el valor en tu cuenta.
          </p>
        </section>

        <section>
          <h3>8. Responsabilidad del cliente</h3>
          <ul>
            <li>Mantener la tarjeta activa y con el monto suficiente.</li>
            <li>Actualizar los datos en el link de pago que te llegará por correo electrónico si cambias de tarjeta.</li>
            <li>Revisar las notificaciones y actuar ante cualquier aviso de cobro fallido.</li>
          </ul>
        </section>

        <section>
          <h3>9. Renovación automática</h3>
          <p>
            Tu seguro se renueva automáticamente para que no pierdas la cobertura, por lo que SURA seguirá haciendo los cobros en los días
            acordados. Si no deseas continuar con la renovación, puedes expresarlo al momento de recibir la comunicación previa a la
            renovación o puedes cancelar tu seguro antes del siguiente cobro.
          </p>
        </section>

        <section class="contact">
          <h3>10. Contacto</h3>
          <p>Si quieres actualizar tu medio de pago, cancelar el débito o hacer una consulta, comunícate con nosotros a través de:</p>
          <ul>
            <li><span>📞</span> #888</li>
            <li>🌐 Sura.co o Seguros digitales SURA</li>
            <li>📧 soportetisuratech&#64;sura.com</li>
          </ul>
        </section>
      </section>
    </div>

    <div class="modal-footer">
      <app-button [text]="'Cerrar'" [type]="'alter'" [size]="'small'" (clicked)="close()"></app-button>
      <app-button [text]="'Aceptar'" [type]="'primary'" [size]="'small'" (clicked)="accept()"></app-button>
    </div>
  </div>
</div>
